import template from './sw-product-detail-base-override.html.twig';

Shopware.Component.override('sw-product-detail-base', // <-- this is the original component (tab "general" of the product detail page)
    {
        template
    }
);
